// YAML wird als Raw-String importiert (Vite ?raw)
import rawYaml from "@theme-styles/config.yaml?raw";
import { parse } from "yaml";
import type { ThemeConfig } from "./types";

const parsed = parse(rawYaml) as Omit<ThemeConfig, "id">;
declare const __THEME_ID__: string;
const themeId = __THEME_ID__;

export const config: ThemeConfig = { ...parsed, id: themeId };
